export default __webpack_public_path__ + "static/media/cap.dfd7b666.svg";